import { ConfirmDialog } from "@avenue-8/sidekick-ui";
import { useUIStore } from "@store/ui.store";

export const AppConfirmDialog = () => {
  const globalConfirmDialog = useUIStore((state) => state.globalConfirmDialog);

  return (
    <ConfirmDialog
      open={globalConfirmDialog?.resolve != null}
      dialogTitle={globalConfirmDialog?.title}
      onCancel={
        globalConfirmDialog?.cancelButtonText === false
          ? undefined
          : () => globalConfirmDialog?.resolve?.(false)
      }
      onConfirm={() => globalConfirmDialog?.resolve?.(true)}
      dialogContent={globalConfirmDialog?.content}
      confirmLabel={globalConfirmDialog?.confirmButtonText}
      cancelLabel={globalConfirmDialog?.cancelButtonText}
      maxWidth={globalConfirmDialog.maxWidth}
      fullWidth={globalConfirmDialog.fullWidth}
    />
  );
};
